import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './utils'
import { TagTypes } from './types'
import { BOLT_BACKEND_TAGS } from 'store/queries/bolt-backend/constants.ts'

export const boltApi = createApi({
  reducerPath: 'boltApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [...Object.values(TagTypes), ...Object.values(BOLT_BACKEND_TAGS)],
  endpoints: () => ({}) // Endpoints are injected in the subfolders. Naming is based on the API route.
})
